import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    showFirstCardAnimation: true,
    showSecondCardAnimation: true,
    playedOnlyOnce: false,
    showQuestionMark: false,
}

const scenarioDetailsSlice = createSlice({
    name: 'scenarioDetails',
    initialState,
    reducers: {
        setShowFirstCardAnimation: (state, action) => {
            state.showFirstCardAnimation = action.payload
        },
        setShowSecondCardAnimation: (state, action) => {
            state.showSecondCardAnimation = action.payload
        },
        setPlayedOnlyOnce: (state)=>{
            state.playedOnlyOnce = true
        },
        setShowQuestionMark: (state) => {
            state.showQuestionMark = true
        },
        resetScenarioDetails: () => initialState
    }
})

export const { setShowFirstCardAnimation, setShowSecondCardAnimation, setPlayedOnlyOnce, setShowQuestionMark, resetScenarioDetails } = scenarioDetailsSlice.actions
export const selectScenarioDetails = (state) => state.scenarioDetails
export default scenarioDetailsSlice.reducer